import axios, { HttpStatusCode } from "axios";
import { logoutAsync } from "../authentication/authenticationSlice";
import { store } from "../../app/store";
import { API_BASE_URL } from "../../config";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (requestConfig) => {
    const token = store.getState().authentication.userAuth?.access_token;
    if (token) {
      requestConfig.headers["Authorization"] = `Bearer ${token}`;
    }

    return requestConfig;
  },
  async (error) => {
    const { response } = error;
    if (response.status === HttpStatusCode.Unauthorized) {
      store.dispatch(logoutAsync());
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response } = error;
    if (response.status === HttpStatusCode.Unauthorized) {
      store.dispatch(logoutAsync());
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
